import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const sessionListStyleId = 'wb-v2-session-list-theme';

export const sessionListBridgeStyles = {
  'wb-session-list': {
    '--local-session-list-heading-font-family': tokens.font.family.display,
    '--local-session-list-heading-font-size': tokens.font.size.displaySm,
    '--local-session-list-heading-font-weight': tokens.font.weight.semibold,
    '--local-session-list-heading-line-height': tokens.lineHeight.displaySm,
    '--local-session-list-heading-color': tokens.color.text.primary,

    '--local-session-list-description-font-family': tokens.font.family.body,
    '--local-session-list-description-font-size': tokens.font.size.textSm,
    '--local-session-list-description-font-weight': tokens.font.weight.regular,
    '--local-session-list-description-line-height': tokens.lineHeight.textSm,
    '--local-session-list-description-color': tokens.color.text.tertiary,

    '--local-session-list-try-again-bg': tokens.color.background.secondary,
    '--local-session-list-try-again-color': tokens.color.text.tertiary,
    '--local-session-list-try-again-font-family': tokens.font.family.body,
    '--local-session-list-try-again-font-size': tokens.font.size.textSm,
    '--local-session-list-try-again-font-weight': tokens.font.weight.medium,
    '--local-session-list-try-again-line-height': tokens.lineHeight.textSm,
    '--local-session-list-try-again-radius': tokens.radius.sm,

    '--local-session-list-gap': tokens.spacing.lg,
  },
};
